import React, { useContext } from 'react';
import { FeatureFlagsContext } from './FeatureFlagProvider';

/**
 * This converts a hook (for useContext) and passes it down to connected components.
 */
export const withFeatureFlagContext = <P extends object>(Component: React.ComponentType<P>) => {
  const FieldErrorContext: React.FunctionComponent = (props) => {
    const context = useContext(FeatureFlagsContext);

    return <Component {...(props as P)} features={context} />;
  };

  return FieldErrorContext;
};
